import { create } from "zustand";



export const useJobStore = create((set, get) => ({
  accessToken: localStorage.getItem("accessToken") || "",
  apiBaseUrl: process.env.REACT_APP_BASE_URL,

  jobPositions: [],
  loading: false,
  error: null,

  fetchJobPositions: async () => {
    const { accessToken, apiBaseUrl } = get();

    set({ loading: true, error: null });

    try {
      const headers = new Headers();
      headers.append("Authorization", accessToken ? `Bearer ${accessToken}` : "");

      const response = await fetch(`${apiBaseUrl}/job-positions`, {
        method: "GET",
        headers,
        redirect: "follow"
      });

      const data = await response.json();

      set({ jobPositions: data, loading: false });
    } catch (err) {
      set({ error: err.message, loading: false });
    }
  }
}));
